var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticStyle: { "text-align": "center" },
            attrs: {
              loading: _vm.loading && !_vm.records,
              color: _vm.loadingColor,
            },
          }),
          _vm._v(" "),
          _vm.records
            ? _c("div", { staticClass: "drugs_list" }, [
                _vm.loading
                  ? _c("div", { staticClass: "loading_block" }, [
                      _c(
                        "div",
                        { staticClass: "cover-loading" },
                        [
                          _c("pulse-loader", {
                            staticStyle: { "text-align": "center" },
                            attrs: { loading: true, color: _vm.loadingColor },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showMyProjects,
                        expression: "showMyProjects",
                      },
                    ],
                    attrs: { type: "checkbox", id: "ch_1" },
                    domProps: {
                      checked: Array.isArray(_vm.showMyProjects)
                        ? _vm._i(_vm.showMyProjects, null) > -1
                        : _vm.showMyProjects,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.showMyProjects,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.showMyProjects = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.showMyProjects = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.showMyProjects = $$c
                          }
                        },
                        _vm.updateRecords,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "ml-1 pointer", attrs: { for: "ch_1" } },
                    [_vm._v("Показать только мои проекты")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l([1, 2], function (column) {
                    return _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "table",
                        { staticClass: "table table-sm table-hover" },
                        [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.getSortedDrugs(), function (drug, i) {
                                return [
                                  i <
                                    Math.round(
                                      Object.keys(_vm.drugs).length / 2
                                    ) *
                                      column &&
                                  i >=
                                    Math.round(
                                      Object.keys(_vm.drugs).length / 2
                                    ) *
                                      (column - 1)
                                    ? [
                                        _c("tr", [
                                          _c("td", [_vm._v(_vm._s(drug.id))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(drug.title)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getRequestedQty(drug.id)
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm.getRemainQty(drug.id))
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.extraDrugs.length
                    ? _c(
                        "table",
                        {
                          staticClass:
                            "table mt-0 table-sm table-hover table-small-td",
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.extraDrugs, function (d, i) {
                              return _c("tr", [
                                _c("td", [_vm._v(_vm._s(i + 1))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(d.title))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-danger btn-sm",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          _vm.extraDrugs =
                                            _vm.extraDrugs.filter(
                                              (dd) => dd.id !== d.id
                                            )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-trash",
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.records
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.loading
              ? _c(
                  "div",
                  [
                    _c("pulse-loader", {
                      staticStyle: { "text-align": "center" },
                      attrs: { loading: _vm.loading, color: _vm.loadingColor },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _vm.paginator
                      ? _c("p", [
                          _vm._v("Всего заявок: "),
                          _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 8,
                            "margin-pages": 2,
                            "click-handler": _vm.getRequestedDrugs,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function ($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ordersList", { attrs: { orders: _vm.records } }),
                    _vm._v(" "),
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 8,
                            "margin-pages": 2,
                            "click-handler": _vm.getRequestedDrugs,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function ($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складе")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }